import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { finalize, Observable, tap } from 'rxjs';
import { RequestChange } from 'src/app/models/request-change';
import { SolicitacaoTroca, Solicitacoes } from 'src/app/models/solicitacao-troca';
import { TurnoService } from 'src/app/services/turno/turno.service';
import { DeclineRequestChangeScaleComponent } from '../decline-request-change-scale/decline-request-change-scale.component';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-scale-change-requests-new',
  templateUrl: './scale-change-requests-new.component.html',
  styleUrls: ['./scale-change-requests-new.component.scss'],
  encapsulation: ViewEncapsulation.None // Desativa encapsulamento para estilos globais
})
export class ScaleChangeRequestsNewComponent implements OnInit, AfterViewInit {
  @ViewChild('slidesContainer') slidesContainer!: ElementRef;

  constructor(
    private modalController: ModalController,
    private turnoService: TurnoService,
    private alertController: AlertController,
    private loadingService: LoadingService,
    private navCtrl: NavController
  ) { }

  @Input() periodo!: string;

  @Input() tabSelected: 'concretizadas' | 'pendentes' = 'pendentes';

  solicitacoes$!: Observable<Solicitacoes>;

  ngOnInit() {
    this.loadingService.presentLoading()
    this.solicitacoes$ = this.turnoService.carregarSolicitacoesTroca(1).pipe(finalize(() => this.loadingService.dismissLoading()));
  }

  handleChangeTab(tab: 'concretizadas' | 'pendentes' ) {
    this.tabSelected = tab;
  }

  handleShowMore() {
    this.modalController.dismiss();
    this.navCtrl.navigateForward(['scale', 'requests-change']);
  }

  public cancel() {
    return this.modalController.dismiss(null, 'cancel');
  }


  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;

  ngAfterViewInit(): void {
    const slider = this.slidesContainer.nativeElement;

    // Eventos de mouse
    slider.addEventListener('mousedown', (e: MouseEvent) => this.startDrag(e));
    slider.addEventListener('mouseleave', () => this.endDrag());
    slider.addEventListener('mouseup', () => this.endDrag());
    slider.addEventListener('mousemove', (e: MouseEvent) => this.drag(e));

    // Eventos de toque
    slider.addEventListener('touchstart', (e: TouchEvent) => this.startTouchDrag(e));
    slider.addEventListener('touchend', () => this.endDrag());
    slider.addEventListener('touchmove', (e: TouchEvent) => this.touchDrag(e));
  }

  private startDrag(e: MouseEvent): void {
    this.isDragging = true;
    const slider = this.slidesContainer.nativeElement;

    // Salva a posição inicial do mouse e a posição de rolagem
    this.startX = e.pageX - slider.offsetLeft;
    this.scrollLeft = slider.scrollLeft;

    // Altera o cursor para indicar que está arrastando
    slider.style.cursor = 'grabbing';

    // Previne a seleção de texto durante o arrasto
    e.preventDefault();
  }

  private startTouchDrag(e: TouchEvent): void {
    if (e.touches.length === 1) {
      this.isDragging = true;
      const slider = this.slidesContainer.nativeElement;

      // Salva a posição inicial do toque e a posição de rolagem
      this.startX = e.touches[0].pageX - slider.offsetLeft;
      this.scrollLeft = slider.scrollLeft;
    }
  }

  private drag(e: MouseEvent): void {
    if (!this.isDragging) return;

    const slider = this.slidesContainer.nativeElement;
    // Calcula o quanto deve rolar
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - this.startX) * 1.5; // Multiplicador de velocidade

    // Aplica a rolagem
    slider.scrollLeft = this.scrollLeft - walk;
  }

  private touchDrag(e: TouchEvent): void {
    if (!this.isDragging) return;

    // Evita que a página role enquanto arrastamos
    e.preventDefault();

    const slider = this.slidesContainer.nativeElement;
    // Calcula o quanto deve rolar
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walk = (x - this.startX) * 1.5; // Multiplicador de velocidade

    // Aplica a rolagem
    slider.scrollLeft = this.scrollLeft - walk;
  }

  private endDrag(): void {
    this.isDragging = false;
    const slider = this.slidesContainer.nativeElement;

    // Restaura o cursor
    slider.style.cursor = 'grab';
  }

  reprove(requestData: SolicitacaoTroca) {
    this.modalController.create({
      component: DeclineRequestChangeScaleComponent,
      componentProps: {
        requestData: requestData
      }
    }).then((modal) => {
      modal.present()
      modal.onDidDismiss().then((_) => this.modalController.dismiss());
    })
  }

  async confirmSolicitacaoTroca(solicitacao: SolicitacaoTroca) {
    const alert = await this.alertController.create({
      header: 'Confirmar solicitação',
      message: 'Deseja confirmar esta solicitação de troca de turno?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Confirmar',
          handler: () => {
            this.processarConfirmacaoTroca(solicitacao);
          }
        }
      ]
    });

    await alert.present();
  }

  private async processarConfirmacaoTroca(solicitacao: SolicitacaoTroca) {
    await this.loadingService.presentLoading();
    this.turnoService.aprovarSolicitacaoTroca(solicitacao.id.toString())
      .pipe(
        tap(() => {
          this.modalController.dismiss();
        }),
        finalize(async () => {
          this.loadingService.dismissLoading();
        })
      )
      .subscribe();
  }



}
